/** Whitespace-separated words, excluding standalone typographic separators. */
export function spokenWordCount(text: string): number { return text.trim().split(/\s+/).filter(word => /[\p{L}\p{N}]/u.test(word)).length; }
export function spokenSeconds(text: string): number { return Math.max(5, Math.round(spokenWordCount(text) / 2.6 / 5) * 5); }
